import { Answers } from '../../constants/apis';
import type { AnswerChild, FeedbackShare } from '../../types/feedbacks';
import { ApiManager } from '../axios-config';

export const updateAnswer = async (
  answerId: AnswerChild['id'],
  content: AnswerChild['content'],
  ranges: AnswerChild['ranges'],
  mentions: FeedbackShare['mentions'],
  token: string,
) => {
  return ApiManager.put(
    `${Answers}/${answerId}`,
    {
      content,
      ranges,
      mentions,
    },
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
};

export const trashAnswer = async (answerId: AnswerChild['id'], token: string) => {
  return ApiManager.put(
    `${Answers}/trash`,
    { ids: [answerId] },
    { headers: { Authorization: `Bearer ${token}` } },
  );
};
